import { Injectable } from '@angular/core';
import { PHBHPApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/lib/ph-bhp-api.service';

@Injectable({
  providedIn: 'root'
})
export class PHBHPFeaturePackageAuthorizationService {

  constructor(private service: PHBHPApiService) { }

  logInUser(data) {
    return this.service.postApi("Accounts/Authenticate", data, false);
    
  }

  getTokenProfileser() {
    //return this.service.getApi("Accounts/GetTokenProfile", true);
    return this.service.getApi("UserProfile/GetTokenProfile", true);
  }
  InitiatePasswordReset(userName) {
    var data = {
      userName : userName,
      languageCode : localStorage.getItem("selectedlanguage")
    }
    return this.service.postApi(`Accounts/InitiatePasswordReset`,data, false);
  }

  passwordReset(validationKey) {
    var data = {
      userName : validationKey,
      languageCode : localStorage.getItem("selectedlanguage")
    }
    return this.service.postApi(`Accounts/PasswordReset`,data, false);
  }

  changePassword(data){
    return this.service.putApi(`Accounts/ChangePassword`,data, true);
  }
  
  CreateDeviceInfo(data) {
    return this.service.postApi('PushNotification/CreateNotification', data, true);
  }
  getProductVersionList() {
    return this.service.getApi('ProductVersion/GetVersionDetails', true);
  }
  policyCheckApi(userId){
    return this.service.putApi(`Users/PolicyAgreed/${userId}`, undefined, true);
  }
  getTermsAndconditions(userId,templateType,languageCode){
    return this.service.getApi(`Users/GetConsentForm/${userId}/${templateType}/${languageCode}`, true);
  }
  getTemplate(templateType,languageCode){
    return this.service.getApi(`Users/GetTemplate/${templateType}/${languageCode}`, true);
  }
}